import { MentoringProgramActionItemTemplate, TemplateAssignedRole } from 'redux/schemas/models/mentoring-program-action-item-templates';

export const NEW_ACTION_ITEM_ID = 'new' as const;
export const ADD_LINK_ID = 'add-link' as const;

export type PreAssignedActionItem = Omit<MentoringProgramActionItemTemplate, 'id' | 'assignedRole' | 'propagated'> & {
  id: number | typeof NEW_ACTION_ITEM_ID | typeof ADD_LINK_ID;
  assignedRole: TemplateAssignedRole | null;
};

// Narrowed type for rows that have been persisted (orchestrator guarantees id is numeric)
export type SavedActionItem = Omit<PreAssignedActionItem, 'id'> & { id: number };

export type PreAssignedActionItemFormData = {
  description: string;
  assignedRole: TemplateAssignedRole | null;
  required: boolean;
};

export type ActionItemRowHandlers = {
  editingId: number | null;
  setEditingId: (id: number | null) => void;
  setShowAddRow: (show: boolean) => void;
  onSave: (formData: PreAssignedActionItemFormData, itemId: number | typeof NEW_ACTION_ITEM_ID) => void;
  onDelete: (id: number) => void;
  onHasUnsavedChanges: (hasChanges: boolean) => void;
};

export const buildAssigneeRoleOrder = (mentorsAlias: string, menteesAlias: string) => [
  { role: TemplateAssignedRole.MENTOR, text: mentorsAlias },
  { role: TemplateAssignedRole.MENTEE, text: menteesAlias },
];

export enum ColumnID {
  DESCRIPTION = 'description',
  ASSIGNEE = 'assignee',
  REQUIRED = 'required',
  OPTIONS = 'options',
}

